import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loadData } from "../../Utils/localStorage";

export const getAllFacilities = createAsyncThunk(
  "getAllFacilities",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + "/api/facility/facility_list",
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "content-type": "application/json",
            Authorization: loadData("Auth"),
          },
        }
      );
      const result = await response.json();
      return result;
    } catch (err) {
      return rejectWithValue("Opps found an error", err.response.data);
    }
  }
);

//facilities by id
export const getFacilitiesDetailsbyId = createAsyncThunk(
  "getFacilitiesDetailsById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/facility/facility_list/${id}`,
        {
          method: "POST",
          body: JSON.stringify({
            club_id: loadData("Club_id"),
            user_id: loadData("Token"),
            request_by: "Admin",
          }),
          headers: {
            "content-type": "application/json",
            Authorization: loadData("Auth"),
          },
        }
      );
      const result = await response.json();

      return result;
    } catch (err) {
      return rejectWithValue(
        "Opps found an error in getEventsDetailsById",
        err.response.data
      );
    }
  }
);

//bookingRequest
export const getBookingRequest = createAsyncThunk(
  "getBookingRequest",
  async (args, { rejectWithValue }) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + "/api/facility/booking_history",
        {
          method: "POST",
          body: JSON.stringify(args),
          headers: {
            "content-type": "application/json",
            Authorization: loadData("Auth"),
          },
        }
      );
      const result = await response.json();

      return result;
    } catch (err) {
      return rejectWithValue("Opps found an error", err.response.data);
    }
  }
);

//bookingRequestbyId
export const getBookingRequestById = createAsyncThunk(
  "getBookingRequestById",
  async ({ args, facilitiesActiveTab }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/facility/booking_history/${facilitiesActiveTab}`,
        {
          method: "POST",
          body: JSON.stringify(args),
          headers: {
            "content-type": "application/json",
            Authorization: loadData("Auth"),
          },
        }
      );
      const result = await response.json();
      return result;
    } catch (err) {
      return rejectWithValue("Opps found an error", err.response.data);
    }
  }
);

//bookingHistory
export const getBookingHistory = createAsyncThunk(
  "getBookingHistory",
  async (args, { rejectWithValue }) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + "/api/facility/booking_history",
        {
          method: "POST",
          body: JSON.stringify(args),
          headers: {
            "content-type": "application/json",
            Authorization: loadData("Auth"),
          },
        }
      );
      const result = await response.json();
      return result;
    } catch (err) {
      return rejectWithValue("Opps found an error", err.response.data);
    }
  }
);

export const facilitiesSlice = createSlice({
  name: "facilitiesSlice",
  initialState: {
    facilitiesList: [],
    facilitiesDetails: {},
    facilitiesActiveTab: "",
    bookingRequestFacilities: [],
    totalBookingRequestCount: "",
    bookingHistoryFacilities: [],
    totalBookingHistoryCount: "",
    loading: false,
    error: null,
    Loader: false,
  },
  reducers: {
    handleFacilitiesActiveTab: (state, action) => {
      state.facilitiesActiveTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllFacilities.pending, (state, action) => {
        state.loading = true;
        state.Loader = true;
      })
      .addCase(getAllFacilities.fulfilled, (state, action) => {
        state.facilitiesActiveTab = action?.payload?.data[0]?.id;
        state.facilitiesList = action?.payload?.data;
        state.loading = false;
        state.Loader = false;
      })
      .addCase(getAllFacilities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.Loader = false;
      })
      .addCase(getFacilitiesDetailsbyId.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getFacilitiesDetailsbyId.fulfilled, (state, action) => {
        state.loading = false;
        state.facilitiesDetails = action.payload?.data[0];
      })
      .addCase(getFacilitiesDetailsbyId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getBookingRequest.pending, (state, action) => {
        state.loading = true;
        state.Loader = true;
      })
      .addCase(getBookingRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingRequestFacilities = action.payload.data;
        state.totalBookingRequestCount = action.payload.total_records;
        state.Loader = false;
      })
      .addCase(getBookingRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.Loader = false;
      })
      .addCase(getBookingHistory.pending, (state, action) => {
        state.loading = true;
        state.Loader = true;
      })
      .addCase(getBookingHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingHistoryFacilities = action.payload.data;
        state.totalBookingHistoryCount = action.payload.total_records;
        state.Loader = false;
      })
      .addCase(getBookingHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.Loader = false;
      })
      .addCase(getBookingRequestById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getBookingRequestById.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingRequestFacilities = action.payload.data;
        state.totalBookingRequestCount = action.payload.total_records;
      })
      .addCase(getBookingRequestById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { handleFacilitiesActiveTab } = facilitiesSlice.actions;
export default facilitiesSlice.reducer;
